<script>
	import formBase from '@_system/components/base/form.vue'
	import newcollectionBox from './box/newcollection.vue'
	export default {
		extends: formBase,
		name: 'paymentapplicationtskForm',
		render(h) {
			this.$slots.plug = [
				<newcollection-box ref="newcollectionBox" onSubmit={this.newcollectionBoxSubmit}  />
			]
			return formBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			exchange_noButton(){
				this.loading = true
				let exchange_no = this.fApi.getValue('exchange_no')
				this.$api.paymentapplicationtsk.getExchange({
					exchange_no:exchange_no,
				}).then((res)=>{
					this.loading = false
					this.fApi.setValue('exchange_uid',res.exchange_uid)
					this.fApi.setValue('receivable_fee',res.receivable_fee)
				},()=>{
					this.loading = false
					this.fApi.setValue('exchange_no',null)
					this.fApi.setValue('exchange_uid',null)
					this.fApi.setValue('receivable_fee',null)
				})
			},
			typeChange(e){
				let fields = [
					'newcollectioncode',
					'newcollectionamount',
				]
				fields.forEach((item)=>{
					let rule =  this.fApi.getRule(item)
					if(e==1){
						this.fApi.updateRule(item, {
							hidden:false,
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:true
							}]
						})
					}else{
						this.fApi.setValue(item,null)
						this.fApi.updateRule(item, {
							hidden:true,
							validate: [{
								message:rule.validate[0].message,
								pattern:rule.validate[0].pattern,
								required:false
							}]
						})
					}
				})
			},
			
			beforeSubmit(formData, next) {
				// if(parseFloat(formData.collectionamount) != parseFloat(formData.newcollectionamount)){
				// 	this.$message.error('两张收款单金额不一致')
				// 	return
				// }
				next()
			},
			beforeInit(next){
				next()
			},
			newcollectionBoxSubmit(e){
				if(e.data){
					this.fApi.setValue('newcollectionid',e.data.id)
					this.fApi.setValue('newcollectioncode',e.data.code)
					this.fApi.setValue('newcollectionamount',e.data.amount)	
				}
			},
			newcollectioncodeButton(){
				this.$refs.newcollectionBox.box.initList()
				this.$refs.newcollectionBox.box.alertBox()
			},
			afterBoxSubmit(e){
				console.log(e.data)
				this.fApi.setValue('collectionaccount',e.data.account)
				this.loading = true
				if(e.data.bankflowtype == 'nb'){
					this.fApi.setValue('isauto',5)
					this.$api.paymentapplicationtsk.getbankinfo({
						serialId:e.data.serialId,
						type:e.data.bankflowtype
					}).then((res)=>{
						this.loading = false
						this.fApi.setValue('accName',res.accName)
						this.fApi.setValue('bankAcc',res.bankAcc)
						this.fApi.setValue('corpCode',res.corpCode)
						this.fApi.setValue('rcvAcc',res.rcvAcc)
						this.fApi.setValue('rcvBankName',res.rcvBankName)
						this.fApi.setValue('rcvName',res.rcvName)						
					},()=>{
						this.loading = false
					})
				}else{
					console.log(window.systemMethods)
					this.fApi.setValue('isauto',6)
					this.fApi.setValue('bankAcc',window.systemMethods.getbankaccount(e.data.account))
				}
				this.fApi.setValue('amount',e.data.amount)
				this.$api.paymentapplicationtsk.listTrades({
					tp_tid:e.data.ordercode,
				}).then((res)=>{
					this.loading = false
					this.fApi.setValue('customerid',res.customerid)
					this.fApi.setValue('customername',res.customername)
				},()=>{
					this.loading = false
				})
			}
		},
		components: {
			newcollectionBox
		}
	}
</script>
